document.addEventListener('DOMContentLoaded', function () {
  // The modal lives inside a `position: sticky` column (.product__column-sticky),
  // which creates its own stacking context — no z-index inside it can ever
  // out-rank the header, regardless of value. Move it to <body> so its
  // z-index is compared against the header directly.
  document.querySelectorAll('.color-compare-overlay').forEach(function (overlay) {
    document.body.appendChild(overlay);
  });

  // Keep the horizontally-scrolling color swatch row (mobile) scrolled to
  // whichever color is currently selected, even after a fresh page load
  // (each swatch is a link that navigates to that color's product page).
  function scrollSelectedSwatchIntoView() {
    if (window.matchMedia('(min-width: 990px)').matches) return; // desktop wraps to lines, no scroll needed
    document.querySelectorAll('.product-cross-links-list').forEach(function (list) {
      var selectedThumb = list.querySelector('.cl-item-selected');
      if (!selectedThumb) return;
      var item = selectedThumb.closest('.product-cross-link-item') || selectedThumb;
      var containerWidth = list.clientWidth;
      var itemLeft = item.offsetLeft;
      var itemWidth = item.offsetWidth;
      list.scrollLeft = itemLeft - (containerWidth / 2) + (itemWidth / 2);
    });
  }
  scrollSelectedSwatchIntoView();

  // NOTE: mobile Safari fires `resize` when its address bar / toolbar
  // collapses or expands — which happens during the exact swipe gesture
  // used to scroll this row. Re-centering on every `resize` was snapping
  // scrollLeft back to the selected swatch mid-scroll (and mid-tap),
  // which made the row feel unscrollable and unclickable. Only recenter
  // on a genuine width change (real resize / orientation change), never
  // on a height-only change.
  var lastWidthForSwatchRecenter = window.innerWidth;
  window.addEventListener('resize', function () {
    if (window.innerWidth === lastWidthForSwatchRecenter) return;
    lastWidthForSwatchRecenter = window.innerWidth;
    scrollSelectedSwatchIntoView();
  });

  document.querySelectorAll('[data-compare-open]').forEach(function (trigger) {
    trigger.addEventListener('click', function () {
      var targetId = trigger.getAttribute('data-compare-target');
      var overlay = document.getElementById(targetId);
      if (!overlay) return;
      overlay._returnFocus = trigger;
      overlay.classList.add('is-open');
      overlay.setAttribute('aria-hidden', 'false');
      overlay.inert = false;
      document.body.style.overflow = 'hidden';
      var openEvent = new CustomEvent('color-compare:open');
      overlay.dispatchEvent(openEvent);
    });
  });

  document.querySelectorAll('.color-compare-overlay').forEach(function (overlay) {
    var t = {
      pickTwo: overlay.getAttribute('data-compare-pick-two'),
      pickOneMore: overlay.getAttribute('data-compare-pick-one-more'),
      compare: overlay.getAttribute('data-compare-compare'),
      soldOut: overlay.getAttribute('data-compare-sold-out'),
      adding: overlay.getAttribute('data-compare-adding'),
      added: overlay.getAttribute('data-compare-added'),
      error: overlay.getAttribute('data-compare-error')
    };

    var swatchBtns = overlay.querySelectorAll('[data-compare-swatch]');
    var goBtn = overlay.querySelector('[data-compare-go]');
    var picker = overlay.querySelector('[data-compare-picker]');
    var view = overlay.querySelector('[data-compare-view]');
    var imgLeft = overlay.querySelector('[data-compare-img-left]');
    var imgRight = overlay.querySelector('[data-compare-img-right]');
    var labelLeft = overlay.querySelector('[data-compare-label-left]');
    var labelRight = overlay.querySelector('[data-compare-label-right]');
    var sizeLeft = overlay.querySelector('[data-compare-size-left]');
    var sizeRight = overlay.querySelector('[data-compare-size-right]');
    var addLeftBtn = overlay.querySelector('[data-compare-add-left]');
    var addRightBtn = overlay.querySelector('[data-compare-add-right]');
    var backBtn = overlay.querySelector('[data-compare-back]');
    var closeBtns = overlay.querySelectorAll('[data-compare-close]');
    var panel = overlay.querySelector('[role="dialog"]');

    function getSelected() {
      return Array.prototype.filter.call(swatchBtns, function (btn) {
        return btn.getAttribute('aria-pressed') === 'true';
      });
    }

    function preselectCurrent() {
      var currentBtn = overlay.querySelector('[data-compare-swatch][data-is-current="true"]');
      if (currentBtn) currentBtn.setAttribute('aria-pressed', 'true');
    }

    function updateGoState() {
      var selected = getSelected();
      var ready = selected.length === 2;
      if (goBtn) {
        goBtn.disabled = !ready;
        if (ready) {
          goBtn.textContent = t.compare;
        } else if (selected.length === 1) {
          goBtn.textContent = t.pickOneMore;
        } else {
          goBtn.textContent = t.pickTwo;
        }
      }
      swatchBtns.forEach(function (btn) {
        var pressed = btn.getAttribute('aria-pressed') === 'true';
        var lock = !pressed && selected.length >= 2;
        btn.classList.toggle('is-disabled', lock);
        btn.disabled = lock;
      });
    }

    swatchBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var pressed = btn.getAttribute('aria-pressed') === 'true';
        if (pressed) {
          btn.setAttribute('aria-pressed', 'false');
        } else {
          var selected = getSelected();
          if (selected.length >= 2) return;
          btn.setAttribute('aria-pressed', 'true');
        }
        updateGoState();
      });
    });

    function populateSizeSelect(selectEl, variants) {
      selectEl.innerHTML = '';
      if (!variants || !variants.length) {
        selectEl.disabled = true;
        return;
      }
      selectEl.disabled = false;
      var firstAvailableId = null;
      variants.forEach(function (v) {
        var opt = document.createElement('option');
        opt.value = v.id;
        opt.textContent = v.available ? v.title : v.title + t.soldOut;
        if (!v.available) {
          opt.disabled = true;
        } else if (firstAvailableId === null) {
          firstAvailableId = v.id;
        }
        selectEl.appendChild(opt);
      });
      // Default to the first in-stock variant so Add to cart doesn't
      // silently try to add a sold-out variant.
      if (firstAvailableId !== null) {
        selectEl.value = firstAvailableId;
      }
    }

    function addToCart(button, selectEl) {
      var variantId = selectEl.value;
      if (!variantId) return;
      var originalText = button.textContent;
      button.disabled = true;
      button.textContent = t.adding;

      var cartDrawer = document.querySelector('cart-drawer');

      // Match the theme's own product-form.js exactly: FormData body (not JSON),
      // Accept: application/javascript, and no explicit Content-Type (the browser
      // sets the correct multipart boundary itself). Some app/middleware on this
      // store's cart pipeline only handles form submissions correctly, not JSON,
      // which is why the native "Add to cart" button worked but this one didn't.
      var formData = new FormData();
      formData.append('id', variantId);
      formData.append('quantity', 1);
      if (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function') {
        formData.append('sections', cartDrawer.getSectionsToRender().map(function (s) { return s.id; }));
        formData.append('sections_url', window.location.pathname);
      }

      var addUrl = (window.routes && window.routes.cart_add_url) ? window.routes.cart_add_url : '/cart/add.js';
      console.log('Add to cart request:', { addUrl: addUrl });

      fetch(addUrl, {
        method: 'POST',
        headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
        body: formData
      })
        .then(function (res) {
          return res.text().then(function (text) {
            var data;
            try {
              data = JSON.parse(text);
            } catch (parseErr) {
              // Shopify didn't return JSON at all (e.g. an HTML error/password page).
              console.error('Add to cart: non-JSON response', { status: res.status, bodyPreview: text.slice(0, 300) });
              throw new Error('non-json-response');
            }
            if (!res.ok) {
              console.error('Add to cart: request failed', { status: res.status, data: data });
            }
            return data;
          });
        })
        .then(function (data) {
          if (data.status) {
            console.error('Add to cart error from Shopify:', data.message || data.description || data);
            button.textContent = t.error;
            setTimeout(function () {
              button.textContent = originalText;
              button.disabled = false;
            }, 1800);
            return;
          }
          button.textContent = t.added;
          if (cartDrawer) {
            try {
              if (cartDrawer.classList.contains('is-empty')) cartDrawer.classList.remove('is-empty');
              cartDrawer.renderContents(data);
            } catch (err) {
              // Item was added successfully even if the drawer failed to re-render.
              console.error('Cart drawer render failed:', err);
            }
          }
          setTimeout(function () {
            closeOverlay();
            button.textContent = originalText;
            button.disabled = false;
          }, 900);
        })
        .catch(function (err) {
          console.error('Add to cart failed:', err);
          button.textContent = t.error;
          setTimeout(function () {
            button.textContent = originalText;
            button.disabled = false;
          }, 1800);
        });
    }

    if (goBtn) {
      goBtn.addEventListener('click', function () {
        var selected = getSelected();
        if (selected.length !== 2) return;
        var idxA = selected[0].getAttribute('data-index');
        var idxB = selected[1].getAttribute('data-index');
        var dataElA = overlay.querySelector('.color-compare-data[data-index="' + idxA + '"]');
        var dataElB = overlay.querySelector('.color-compare-data[data-index="' + idxB + '"]');
        if (!dataElA || !dataElB) return;
        var dataA = JSON.parse(dataElA.textContent);
        var dataB = JSON.parse(dataElB.textContent);

        imgLeft.src = dataA.image;
        imgLeft.alt = dataA.title;
        imgRight.src = dataB.image;
        imgRight.alt = dataB.title;

        if (labelLeft) labelLeft.textContent = dataA.title;
        if (labelRight) labelRight.textContent = dataB.title;

        if (sizeLeft) populateSizeSelect(sizeLeft, dataA.variants);
        if (sizeRight) populateSizeSelect(sizeRight, dataB.variants);

        picker.hidden = true;
        view.hidden = false;
      });
    }

    if (addLeftBtn && sizeLeft) {
      addLeftBtn.addEventListener('click', function () {
        addToCart(addLeftBtn, sizeLeft);
      });
    }
    if (addRightBtn && sizeRight) {
      addRightBtn.addEventListener('click', function () {
        addToCart(addRightBtn, sizeRight);
      });
    }

    if (backBtn) {
      backBtn.addEventListener('click', function () {
        view.hidden = true;
        picker.hidden = false;
      });
    }

    function closeOverlay() {
      overlay.classList.remove('is-open');
      overlay.setAttribute('aria-hidden', 'true');
      overlay.inert = true;
      document.body.style.overflow = '';
      view.hidden = true;
      picker.hidden = false;
      swatchBtns.forEach(function (btn) {
        btn.setAttribute('aria-pressed', 'false');
      });
      updateGoState();
      if (typeof removeTrapFocus === 'function') {
        removeTrapFocus(overlay._returnFocus || null);
      } else if (overlay._returnFocus) {
        overlay._returnFocus.focus();
      }
    }

    closeBtns.forEach(function (btn) {
      btn.addEventListener('click', closeOverlay);
    });

    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) closeOverlay();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && overlay.classList.contains('is-open')) closeOverlay();
    });

    // Pre-select the color currently being viewed, both on first load
    // and every time this modal is opened.
    preselectCurrent();
    updateGoState();
    overlay.addEventListener('color-compare:open', function () {
      preselectCurrent();
      updateGoState();
      var initialFocus = closeBtns.length ? closeBtns[0] : panel;
      if (initialFocus) initialFocus.focus();
      if (panel && typeof trapFocus === 'function') trapFocus(panel, initialFocus);
    });
  });
});
